const faqs = [
  {
    id: 1,
    question: '爆瓜网的爆料信息可信吗？',
    answer: '爆瓜网坚持多方求证原则，每条爆料均经过专业编辑团队交叉验证信息来源。我们标注了每一条信息的可信度等级，并持续跟踪事件进展，一旦有新证据会第一时间更新。对于未经证实的传闻，我们会明确标注"待核实"。',
  },
  {
    id: 2,
    question: '如何在爆瓜网投稿爆料？',
    answer: '你可以通过页面上的"投稿爆料"入口联系我们，支持邮箱投稿（tips@baogua.com）和微信公众号（搜索"爆瓜网"）两种方式。我们承诺严格保护爆料人隐私信息，所有投稿均采用匿名处理。',
  },
  {
    id: 3,
    question: '爆瓜网的内容多久更新一次？',
    answer: '我们实行7×24小时全天候更新机制，编辑团队实时监控微博热搜、抖音热榜、小红书热门等多个平台。重大突发爆料通常在事发后15分钟内完成初步报道，30分钟内发布详细跟进内容。',
  },
  {
    id: 4,
    question: '爆瓜网有手机App吗？',
    answer: '目前爆瓜网主要以网页版形式提供服务，移动端适配已全面优化，在手机浏览器中访问即可获得流畅的吃瓜体验。App正在开发中，敬请期待。你可以将网站添加到手机桌面，获得类似App的使用体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            吃瓜常见问题
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            关于爆瓜网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-5 text-foreground-900 font-heading font-bold text-base list-none">
                <span>{faq.question}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 group-open:text-primary-600 transition-colors flex-shrink-0 ml-4">
                  <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                </span>
              </summary>
              <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}